/**
 * Brand logos carousel. Images live in: public/images/brands/
 * Add or replace PNG/JPG files there, then add entries below (src: '/images/brands/yourfile.png').
 */
const brandLogos = [
  { src: '/images/brands/classpass.png', alt: 'ClassPass brand logo' },
  { src: '/images/brands/whitefox.png', alt: 'WhiteFox brand logo' },
  { src: '/images/brands/samsung.png', alt: 'Samsung brand logo' },
  { src: '/images/brands/doordash.png', alt: 'DoorDash brand logo' },
  { src: '/images/brands/uber.png', alt: 'Uber brand logo' },
  { src: '/images/brands/Target_logo.png', alt: 'Target brand logo' },
  { src: '/images/brands/crocs.png', alt: 'Crocs brand logo' },
  { src: '/images/brands/disney.png', alt: 'Disney brand logo' },
  { src: '/images/brands/jlo.png', alt: 'JLo brand logo' },
  { src: '/images/brands/laneige.png', alt: 'Laneige brand logo' },
  { src: '/images/brands/ramp.png', alt: 'Ramp brand logo' },
];

export default function GallerySection() {
  // Duplicate list so the carousel loops seamlessly
  const carouselLogos = [...brandLogos, ...brandLogos];

  return (
    <section id="gallery" className="py-6 sm:py-8 bg-blue-100/30">
      <div className="container px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <div className="flex flex-col items-center space-y-3 sm:space-y-4">
            <div className="bg-white/80 backdrop-blur-sm rounded-full px-4 sm:px-6 md:px-8 py-3 sm:py-4 shadow-lg w-full max-w-2xl">
              <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-playfair font-bold text-dark tracking-tight">Brand Partnerships in Creator Profiles</h2>
            </div>
            <div className="bg-gradient-to-r from-primary/20 to-accent/20 rounded-full px-4 sm:px-6 py-2 sm:py-3 shadow-md w-full max-w-xl">
              <h3 className="text-lg sm:text-xl md:text-2xl font-playfair font-semibold text-dark tracking-tight">Real creators, real profiles</h3>
            </div>
          </div>
        </div>
        <div className="overflow-hidden py-4 sm:py-8" aria-label="Brand logos carousel">
          <div className="brand-carousel-track flex items-center gap-6 sm:gap-8 md:gap-12">
            {carouselLogos.map((logo, i) => (
              <div key={`${logo.alt}-${i}`} className="brand-carousel-item flex-shrink-0 rounded-lg overflow-hidden flex items-center justify-center">
                <img src={logo.src} alt={logo.alt} className="w-full h-full object-contain" loading="lazy" />
              </div>
            ))}
          </div>
        </div>
        <p className="text-center text-xs sm:text-sm text-gray-500 mt-4 sm:mt-6 font-dm-sans">
          Logos reflect creators&apos; past partnerships and do not imply endorsement.
        </p>
      </div>
    </section>
  );
}
